(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["duro-recommendations-refresh"] && !Shopify.designMode) return;
  try {
    if (!window.duroRecommendationsListening) {
    window.duroRecommendationsListening = true;
    let timer;
    let pending;
    document.addEventListener('cart:update', () => {
      clearTimeout(timer);
      pending?.abort();
      timer = setTimeout(async () => {
        const ids = [...new Set([...document.querySelectorAll('[data-duro-recommendation-section]')].map(el => el.dataset.duroRecommendationSection))];
        if (!ids.length) return;
        pending = new AbortController();
        const url = new URL(location.href);
        url.searchParams.set('sections', ids.slice(0, 5).join(','));
        try {
          const response = await fetch(url, { signal: pending.signal });
          if (!response.ok) return;
          const sections = await response.json();
          for (const [id, markup] of Object.entries(sections)) {
            if (!markup) continue;
            const next = new DOMParser().parseFromString(markup, 'text/html').getElementById(`shopify-section-${id}`);
            const current = document.getElementById(`shopify-section-${id}`);
            if (next && current) current.replaceChildren(...next.childNodes);
          }
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('Could not refresh matching gear.');
        }
      }, 150);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["duro-size-guide-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-duro-size-guide]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const section = link.closest('.shopify-section');
    const guide = section?.querySelector('#duro-size-guide');
    if (!guide) return;
    event.preventDefault();
    let parent = guide;
    while (parent && parent !== section) {
      if (parent instanceof HTMLDetailsElement) parent.open = true;
      parent = parent.parentElement;
    }
    const summary = guide.querySelector(':scope > summary');
    requestAnimationFrame(() => {
      summary?.focus({preventScroll: true});
      guide.scrollIntoView({behavior: 'instant', block: 'start'});
    });
  });
  } catch(e) { console.error(e); }
})();

})();
